var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"container-full header"},[_vm._t("left",[_c('nav-bar-left')]),_vm._t("right",[_c('nav-bar-user',{style:(_vm.rightShow)})])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }